export const ADMIN = "Admin";
export const TECHNICIAN = "Technician";
export const VIEWER = "Viewer";
export const roles = [ADMIN, TECHNICIAN, VIEWER] as const;
export type Role = (typeof roles)[number];
export const NEW_USER = "new";
export const USER_ACTIVE = "Active";
export const USER_PENDING = "Pending";
